import { Org } from 'api/Orgs/types';
import { inviteUserRequest } from 'api/Users/api';
import { Role, User } from 'api/Users/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { useState } from 'react';
import { notification } from 'antd';

export const useInviteUser = (onUserInvited: (user: User) => void) => {
  const [ isLoading, setIsLoading ] = useState<boolean>(false);

  const inviteUser = (email: string, role: Role, org?: Org) => {
    setIsLoading(true);

    inviteUserRequest(email, role, org?.id)
      .then((response) => {
        onUserInvited(response.data);
      })
      .catch((reason) => {
        notification.error({ duration: 0, type: 'error', message: getErrorFromPromiseReason(reason) });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return { isLoading, inviteUser };
};
